import React from 'react';
import {
	ArrowMoveDownIcon,
	ArrowMoveUpIcon,
	Button,
	NumberInput,
} from '@sharefiledev/flow-web';
import { t } from '../../../../utils';
import {
	PageMoveButtonGroup,
	PageMoveButtonWrapper,
	PageSelectorBar,
	StyledNumberInputWrapper,
	StyledPageCounter,
} from './PageSelector.styled';

export interface Props {
	currentPage: number;
	totalPages: number;
	onPageChange: (newPage: number) => void;
}

const FormattedNumberInput = ({ currentPage, onPageChange, totalPages }: Props) => {
	return (
		<StyledNumberInputWrapper>
			<NumberInput
				aria-label={t('documentView.pageChangeInputLabel')}
				value={currentPage}
				minValue={1}
				maxValue={totalPages}
				onChange={onPageChange}
				disabled={totalPages === 1}
				width="50px"
			/>
		</StyledNumberInputWrapper>
	);
};

export const PageSelector = (props: Props) => {
	const pageString = t('documentView.documentPageIndex', {
		currentPage: <FormattedNumberInput {...props} />,
		totalPages: props.totalPages ?? '?',
	});

	return (
		<PageSelectorBar>
			<StyledPageCounter data-testid={'page-counter'}>{pageString}</StyledPageCounter>
			<PageMoveButtonGroup>
				<Button.Wrapper
					title={t('documentView.pageUp')}
					disabled={props.currentPage === 1}
					onClick={() => props.onPageChange(props.currentPage - 1)}
				>
					<PageMoveButtonWrapper>
						<ArrowMoveUpIcon size={16} />
					</PageMoveButtonWrapper>
				</Button.Wrapper>
				<Button.Wrapper
					title={t('documentView.pageDown')}
					disabled={props.currentPage === props.totalPages}
					onClick={() => props.onPageChange(props.currentPage + 1)}
				>
					<PageMoveButtonWrapper>
						<ArrowMoveDownIcon size={16} />
					</PageMoveButtonWrapper>
				</Button.Wrapper>
			</PageMoveButtonGroup>
		</PageSelectorBar>
	);
};
